export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";